import { render, staticRenderFns } from "./msg-management-config.vue?vue&type=template&id=eefbb8e4&scoped=true"
import script from "./msg-management-config.vue?vue&type=script&lang=js"
export * from "./msg-management-config.vue?vue&type=script&lang=js"
import style0 from "./msg-management-config.vue?vue&type=style&index=0&id=eefbb8e4&prod&scoped=true&lang=css"
import style1 from "./msg-management-config.vue?vue&type=style&index=1&id=eefbb8e4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eefbb8e4",
  null
  
)

export default component.exports